import React from "react";
import { motion } from "framer-motion";
import { CornerDownRight, ChevronsRight } from "lucide-react";
import about_bg from "../../assets/images/blog_banner.png";
import { Link } from "react-router-dom";
const BlogBanner = () => {
  return (
    <section className="relative w-full bg-[#f7f7f5] text-slate-900 overflow-hidden flex items-end pt-36 pb-16 md:pt-44 md:pb-28">
      <div
        className="pointer-events-none  absolute top-1/2
       left-1/2 transform -translate-x-1/2 -translate-y-1/2 h-auto opacity-35 select-none"
      >
        <img
          src={about_bg}
          alt=""
          className="w-full  object-cover"
        />
      </div>
      <div className="mx-auto max-w-7xl flex justify-center items-center px-6  lg:px-12 relative z-10 w-full">
        <div className="max-w-3xl">
          <motion.h1
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
            className="text-balance text-center text-4xl sm:text-6xl md:text-7xl font-semibold tracking-tight text-slate-950  "
          >
            <span className="font-serif italic font-light text-slate-500">
              Blogs
            </span>
          </motion.h1>
          <motion.p
            initial={{ opacity: 0, y: 16 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.55, delay: 0.12, ease: "easeOut" }}
            className="mt-6 text-lg sm:text-xl text-center text-slate-600 max-w-2xl leading-relaxed"
          >
            Discover insights, ideas, and expert knowledge in our latest blogs!
          </motion.p>
          <motion.p
            initial={{ opacity: 0, y: 16 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.55, delay: 0.12, ease: "easeOut" }}
            className="mt-6 text-base text-slate-500  flex flex-row justify-center gap-1 items-center leading-relaxed"
          >
            <Link to="/">Home</Link> <ChevronsRight size={20} /> Blogs
          </motion.p>
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.5, delay: 0.25 }}
            className="mt-7 pt-6 border-t border-slate-300/80 flex items-center justify-center gap-3 text-xs font-mono text-slate-500 tracking-widest uppercase"
          >
            <CornerDownRight size={14} className="text-slate-950" />
            <span>Dive into our latest insights!</span>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default BlogBanner;
